import HttpClient from './httpClient';

const deleteOldCsrf = () => new HttpClient.Builder().get('/drop-old-csrf').unsecured().execute();

export default deleteOldCsrf;
